export default {"src":"/_next/static/media/forty-percent.59c2f47d.svg","height":45,"width":102,"blurWidth":0,"blurHeight":0};